import { Link } from "react-router-dom";
import { Box } from "@mui/material";
import { navArray } from "../../utils/navArray";

const NavBox = ({ isMobile, drawer }) => {
    return (
        <Box 
        className='navBar' 
        display='flex' 
        flexDirection={isMobile ? 'column' : 'row'} 
        gap={isMobile ? 3 : 4} 
        alignItems={isMobile ? 'flex-start' : 'center'}
        p={isMobile ? 2 : null}
        >
            {navArray.map((navItem, index) => {

                if (!isMobile && navItem.onlyMobile === true) {
                    return null;
                }

                return (
                    <Link
                        key={index}
                        to={navItem.path}
                        onClick={() => {
                            
                            if (isMobile && typeof drawer === 'function') drawer()
                        }}
                    >
                        {navItem.name}
                    </Link>
                )
            }


            )}
           
        </Box>
    );
};

export default NavBox;